//Font Awesome
import '../bundle/font-awesome/scss/fontawesome.scss'
import '../bundle/font-awesome/scss/solid.scss'
import '../bundle/font-awesome/scss/brands.scss'
import '../bundle/font-awesome/scss/light.scss'
import '../bundle/font-awesome/scss/regular.scss'
import '../bundle/font-awesome/scss/duotone.scss'

//Front UI
import '../bundle/scss/_variables.scss'
import '../bundle/front-ui/vendor/hs-mega-menu/src/scss/hs-mega-menu.scss'
import '../bundle/front-ui/vendor/slick-carousel/slick/slick.css'
import '../bundle/scss/aos.scss'
import '../bundle/front-ui/scss/theme.scss'


//DYL Specific UI
import '../bundle/scss/landing-pages.scss'
import '../bundle/scss/industries.scss'
import '../bundle/scss/product.scss'


//Stream UI
import '../bundle/css/stream-styles.css'


//Bootstrap UI
import '../bundle/scss/bootstrap-addons.scss'
import '../bundle/scss/styles-global-UI.scss'

//Typing UI
import '../bundle/css/typed.css'

//Media Query Bootstrap
import '../bundle/scss/sm-breakpoints-industry.scss'
import '../bundle/scss/md-breakpoints-industry.scss'
import '../bundle/scss/lg-breakpoints-industry.scss'
import '../bundle/scss/xl-breakpoints.scss'

///////////////Javascript//////////////////
///////////////////////////////////////////
//jQuery, Bootstrap, Popper
import 'jquery'
import '../bundle/js/jquery-migrate.js'
import 'bootstrap'

//Component Vendors
import '../bundle/front-ui/vendor/appear.js'

//Global Theme Setting and Calls
import '../bundle/js/pre-loader.js'
import '../bundle/js/front-init-industry.js'


